import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Parallax from "./components/Parallax";
import VideoSection from "./components/VideoSection";
import TeamGallery from "./components/TeamGallery";
import LabsSection from "./components/LabsSection";
import Transformacion from "./components/Transformacion";
import Unete from "./components/Unete";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <LabsSection />
      <Parallax />
      <VideoSection />
      <TeamGallery />
      <Transformacion />
      <Unete />
      <Footer />
      <CookieBanner />
      <Toaster />
    </div>
  );
}

export default App;
